import MainLayout from '@/common/components/layouts/MainLayout.tsx';
import AboutUsIcon from '@/modules/Dashboard/assets/icons/aboutUsIcon.svg?react';
import InstagramIcon from '@/common/assets/icons/instagramIcon.svg?react';
import WebSiteIcon from '@/common/assets/icons/webSiteIcon.svg?react';
import { Box, Flex } from 'styled-system/jsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';

export default () => (
  <MainLayout title="درباره ما" header="titleHeader">
    <AboutUs />
  </MainLayout>
);

const AboutUs = () => {
  return (
    <Box py="20px">
      <AboutUsIcon width="100%" />
      <TitleDescription textStyle="h2" mb="15px" mt="40px">
        سناپ
      </TitleDescription>
      <Box
        borderRadius="8px"
        backgroundColor="white"
        p="15px"
        boxShadow="cardShadow"
      >
        <Typography textStyle="b2">
          شرکت ایرانیان پوشش در سال 1397 توانست در حوزه IT،شرکت نرم‌افزار سناپ
          (سامانه نوآوری ایرانیان پوشش) را با مجور سازمان صنفی رایانه‌ای کشور
          راه‌اندازی نماید، این شرکت تاکنون ماموریت دیجیتال شدن گروه ایرانیان
          پوشش را بعهده گرفته و علاوه بر ایرانیان پوشش درتمام حوزه‌ها، محصولات
          دیجیتال را برای شرکت‌های بیمه‌ای دیگر از جمله ایران، آسیا، دی و ... به
          انجام رسانده است.
        </Typography>
        <Box my="20px" height="1px" borderBottom="1px solid {colors.gray-2}" />
        <Flex alignItems="center" justifyContent="space-between">
          <Flex
            onClick={() => {
              window.open('https://www.sanaap.com');
            }}
            alignItems="center"
          >
            <Typography ml="5px" color="black-2" textStyle="b4">
              sanaap.co
            </Typography>
            <InstagramIcon />
          </Flex>
          <Flex
            onClick={() => {
              window.open('https://www.sanaap.com');
            }}
            alignItems="center"
          >
            <Typography ml="5px" color="black-2" textStyle="b4">
              www.sanaap.com
            </Typography>
            <WebSiteIcon />
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};
